<template>
  <section class="header">
    <div class="img-slider">
      <div
        class="slide ms2"
        :class="{ activee: active === 1 }">
        <div class="text">
          <div class="left-part">
            <div class="l-cont">
              <h1>{{ $tc('slider.slider1text') }}
              </h1>
              <p />
              <router-link :to="{ name: 'Accounts' }" class="main-btn">{{ $tc('slider.conocer_mas') }}</router-link>
            </div>
          </div>
          <div class="right-part rp-2">
            <div class="img-cont imc-2">
              <img src="@/assets/images/HOME/Slide 1/Grupo 1400@2x.png" alt="">
            </div>
          </div>
        </div>
      </div>

      <div
        class="slide ms4"
        :class="{ activee: active === 2 }">
        <div class="text">
          <div class="left-part">
            <div class="l-cont">
              <h1>{{ $tc('slider.slider2text') }}
              </h1>
              <p />
              <router-link :to="{ name: 'Accounts' }" class="main-btn">{{ $tc('slider.conocer_mas') }}</router-link>
            </div>
          </div>
          <div class="right-part rp-4">
            <div class="img-cont imc-4">
              <img src="@/assets/images/Accounts/Grupo 1675@2x.png" alt="">
            </div>
          </div>
        </div>
      </div>
<!--
      <div
        class="slide ms3"
        :class="{ activee: active === 3 }">
        <div class="text">
          <div class="left-part">
            <div class="l-cont">
              <h1>{{ $tc('slider.slider3text') }}
              </h1>
              <p />
              <router-link :to="{ name: 'Rewards' }" class="main-btn">{{ $tc('slider.conocer_mas') }}</router-link>
            </div>
          </div>
          <div class="right-part rp-3">
            <div class="img-cont imc-3">
              <img src="@/assets/images/HOME/Slide 3/Grupo 1520@2x.png" alt="">
            </div>
          </div>
        </div>
      </div>

      <div
        class="slide ms5"
        :class="{ activee: active === 4 }">
        <div class="text">
          <div class="left-part">
            <div class="l-cont">
              <h1>{{ $tc('slider.slider4text') }}
              </h1>
              <p />
              <router-link :to="{ name: 'Rewards' }" class="main-btn">{{ $tc('slider.conocer_mas') }}</router-link>
            </div>
          </div>
          <div class="right-part rp-5">
            <div class="img-cont imc-5">
              <img src="@/assets/images/HOME/Slide 5/Grupo 1673@2x.png" alt="">
            </div>
          </div>
        </div>
      </div>

      <div
        class="slide ms1"
        :class="{ activee: active === 5 }">
        <div class="text">
          <div class="left-part">
            <div class="l-cont">
              <h1>{{ $tc('slider.slider5text') }}
              </h1>
              <router-link :to="{ name: 'Mundial' }" class="main-btn">{{ $tc('slider.participar') }}</router-link>
            </div>
          </div>
          <div class="right-part rp-1">
            <div class="img-cont imc-1">
              <img src="@/assets/images/HOME/Slide 2/Grupo 1672@2x.png" alt="">
            </div>
          </div>
        </div>
      </div>
-->
      <div class="navigation">
        <div
          v-for="i in 2"
          :key="i"
          class="btn"
          :class="{ activee: i === active }"
          @click="setActive(i)" />
      </div>
    </div>
  </section>
</template>

<script>
export default {
  data () {
    return {
      active: 1,

      timer: null
    }
  },

  created () {
    this.startTimer()
  },

  methods: {
    setActive (i) {
      this.active = i
      this.startTimer()
    },

    startTimer () {
      if (this.timer) {
        clearTimeout(this.timer)
      }

      this.timer = setTimeout(() => {
        this.next()
      }, 6000)
    },

    next () {
      this.setActive(this.active < 2 ? this.active + 1 : 1)
    }
  }
}
</script>
